// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__14EeF","photosFormSection":"styles_photosFormSection__1XR93"};